/** socket.io 协议常量 */
export const packets = {
    open: 0, // non-ws
    close: 1, // non-ws
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
  }
export const events = {
    CONNECT: 0,
    DISCONNECT: 1,
    EVENT: 2,
    ACK: 3,
    ERROR: 4,
    BINARY_EVENT: 5,
    BINARY_ACK: 6
  }
  
export const PING_CHECK_INTERVAL = 5000